import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import useFetchVisaDirectPushTransaction from '@/hooks/useApi/useFetchVisaDirectPushTransaction';
import VisaDirectPushTransactionInfo from './VisaDirectPushTransactionInfo';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type VisaDirectPushTransactionContainerProps = {
  TransactionID: string;
} & Omit<ComponentProps<typeof VisaDirectPushTransactionInfo>, 'transaction'>;

export default function VisaDirectPushTransactionContainer({
  TransactionID,
  isParent = false,
  jwt,
  ELinxRequestID = '',
  ...props
}: VisaDirectPushTransactionContainerProps) {
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { visaDirectPushTransaction, fetchVisaDirectPushTransaction } = useFetchVisaDirectPushTransaction({
    bearer: jwt,
  });

  useEffect(() => {
    blockingLoader.show();

    fetchVisaDirectPushTransaction(TransactionID)
      .catch((error) => {
        // Not returned: the dialog's promise settles on dismissal, and the loader must drop before that.
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred'));
      })
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  const transaction = visaDirectPushTransaction;

  return (
    <div>
      {transaction && (
        <VisaDirectPushTransactionInfo
          transaction={transaction}
          isParent={isParent}
          jwt={jwt}
          ELinxRequestID={ELinxRequestID}
          {...props}
        />
      )}
    </div>
  );
}
